import React, { useMemo } from 'react';
import { LookupSelect, type LookupSelectProps } from './LookupSelect';
import { labelCurrency } from './lookupHelpers';
import { compareByCurrency, useEndpointLookupOptions } from './useLookupOptions';

const ENDPOINT = '/currencies?page=1&limit=500';

function keepIdsKey(includeIds: LookupSelectProps['includeIds']): string {
  return (includeIds ?? [])
    .map((id: string | number | null | undefined) => (id == null || id === '' ? '' : String(id)))
    .filter(Boolean)
    .join(',');
}

/** Active currencies, ordered by sortOrder. Value is currency code. */
export function CurrencySelect({ includeIds, ...props }: LookupSelectProps) {
  const keepKey = keepIdsKey(includeIds);
  const keepIds = useMemo(() => (keepKey ? keepKey.split(',') : undefined), [keepKey]);
  const { options, isLoading } = useEndpointLookupOptions({
    endpoint: ENDPOINT,
    getLabel: labelCurrency,
    getValue: (item) => String(item.code || item.id || ''),
    keepIds,
    compare: compareByCurrency,
  });
  return (
    <LookupSelect
      {...props}
      includeIds={includeIds}
      options={options}
      isLoading={isLoading}
      placeholder={props.placeholder ?? 'Select currency…'}
      searchPlaceholder={props.searchPlaceholder ?? 'Search currencies…'}
    />
  );
}

export default CurrencySelect;
